import React from 'react';

// Stroke icons for the storefront chrome. They inherit currentColor and are
// decorative by default — give the surrounding control an accessible name.
const Svg = ({ children, size = 20, strokeWidth = 1.7, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    {children}
  </svg>
);

export const IconSearch = (props) => (
  <Svg {...props}><circle cx="11" cy="11" r="6.5" /><path d="m20 20-4.2-4.2" /></Svg>
);

export const IconBag = (props) => (
  <Svg {...props}><path d="M5.5 8.5h13l-1.1 11.5H6.6z" /><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5" /></Svg>
);

export const IconUser = (props) => (
  <Svg {...props}><circle cx="12" cy="8.5" r="3.5" /><path d="M5 20c1.2-3.6 3.8-5.5 7-5.5s5.8 1.9 7 5.5" /></Svg>
);

export const IconChevronDown = (props) => (
  <Svg {...props}><path d="m6 9.5 6 6 6-6" /></Svg>
);

export const IconChevronRight = (props) => (
  <Svg {...props}><path d="m9.5 6 6 6-6 6" /></Svg>
);

export const IconArrowRight = (props) => (
  <Svg {...props}><path d="M4.5 12h15" /><path d="m13.5 6 6 6-6 6" /></Svg>
);

export const IconArrowUpRight = (props) => (
  <Svg {...props}><path d="M7 17 17 7" /><path d="M8.5 7H17v8.5" /></Svg>
);

export const IconClose = (props) => (
  <Svg {...props}><path d="M6 6l12 12M18 6 6 18" /></Svg>
);

export const IconMenu = (props) => (
  <Svg {...props}><path d="M4 7h16M4 12h16M4 17h10" /></Svg>
);

export const IconPhone = (props) => (
  <Svg {...props}>
    <path d="M5.2 4.5h3l1.6 4-2 1.3a11 11 0 0 0 6.4 6.4l1.3-2 4 1.6v3a1.6 1.6 0 0 1-1.7 1.6A15.4 15.4 0 0 1 3.6 6.2a1.6 1.6 0 0 1 1.6-1.7z" />
  </Svg>
);

export const IconMail = (props) => (
  <Svg {...props}><rect x="3.5" y="5.5" width="17" height="13" rx="2" /><path d="m4 7 8 6 8-6" /></Svg>
);

export const IconPin = (props) => (
  <Svg {...props}><path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z" /><circle cx="12" cy="10" r="2.3" /></Svg>
);

export const IconClock = (props) => (
  <Svg {...props}><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></Svg>
);

export const IconCalendar = (props) => (
  <Svg {...props}><rect x="4" y="5.5" width="16" height="14.5" rx="2" /><path d="M4 10h16M8.5 3.5v4M15.5 3.5v4" /></Svg>
);

export const IconCheck = (props) => (
  <Svg {...props}><path d="m5 12.5 4.2 4.2L19 7" /></Svg>
);

export const IconTag = (props) => (
  <Svg {...props}><path d="M3.5 12.2V4.5a1 1 0 0 1 1-1h7.7l8.3 8.3a1 1 0 0 1 0 1.4l-7.1 7.1a1 1 0 0 1-1.4 0z" /><circle cx="8" cy="8" r="1.4" /></Svg>
);

export const IconHeadset = (props) => (
  <Svg {...props}>
    <path d="M4.5 14v-2a7.5 7.5 0 0 1 15 0v2" /><rect x="3.5" y="13.5" width="4" height="6" rx="1.6" /><rect x="16.5" y="13.5" width="4" height="6" rx="1.6" /><path d="M18.5 19.5c0 1.2-1.3 2-3.5 2h-2" />
  </Svg>
);

export const IconSparkle = (props) => (
  <Svg {...props}><path d="M12 3.5 13.8 10 20.5 12l-6.7 2L12 20.5 10.2 14 3.5 12l6.7-2z" /></Svg>
);

export const IconReceipt = (props) => (
  <Svg {...props}><path d="M6 3.5h12v17l-3-1.8-3 1.8-3-1.8-3 1.8z" /><path d="M9 8.5h6M9 12h6M9 15.5h3.5" /></Svg>
);

// Longhorn skull glyph, echoing the split-skull logo. Filled, so size it with
// width in CSS; it keeps a 2:1 aspect ratio.
export const Longhorn = ({ className, title }) => (
  <svg
    className={className}
    viewBox="0 0 120 60"
    fill="currentColor"
    role={title ? 'img' : undefined}
    aria-hidden={title ? undefined : 'true'}
    focusable="false"
  >
    {title && <title>{title}</title>}
    <path d="M3 5C12 16 30 20.5 47 19Q60 16.5 73 19C90 20.5 108 16 117 5C109 20 91 26.5 74 25.5L72.5 31Q70.5 32.5 71.2 35L68.5 49C67.8 53.5 64.5 56 60 56C55.5 56 52.2 53.5 51.5 49L48.8 35Q49.5 32.5 47.5 31L46 25.5C29 26.5 11 20 3 5Z" />
  </svg>
);
